import { addStyles } from 'ethcss'
import { grid, IStyles, mediaCSS } from '../../../theme'

const historyHeaderStyles: IStyles = {
    header: {
        position: 'relative',
        ...grid.row,
        ...grid.normalCenter,
        ...grid.mb_md,
        [mediaCSS.tabMini]: {
            flexWrap: 'wrap',
        },
    },
    downloadLink: {
        ...grid.ml_mini,
        position: 'absolute',
        top: 0,
        right: 0,
        [mediaCSS.tabMini]: {
            position: 'static',
            order: 1,
            marginLeft: 16,
        },
    },
    timezoneSwitch: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,
        marginLeft: 24,
        [mediaCSS.tabMini]: {
            width: '100%',
            order: 2,
            marginTop: 14,
            marginLeft: 0,
        },

        span: {
            marginLeft: 6,
        },
    },
}

addStyles(historyHeaderStyles)
export default historyHeaderStyles
